import React from "react";
import { CompanyDropdownWithoutLoader } from "./CompanyDropdownWithoutLoader";
import { useCompaniesByCustomerId } from "./data/useCompaniesByCustomerId";
import { Autocomplete } from "@mui/material";

interface CompanyDropdownProps {
  customerId: number | undefined;
  selectedCompanyName?: string;
  onCompanyChange: (company: string, companyId?: number) => void;
  showLabel?: boolean;
  showClear?: boolean;
  className?: string;
  clearAuto?: boolean;
  disabled?: boolean;
  width?: string;
}

export const CompanyDropdown = React.forwardRef<typeof Autocomplete, CompanyDropdownProps>((props, ref) => {
  const { customerId, disabled } = props;

  const companies = useCompaniesByCustomerId(customerId);

  return (
    <CompanyDropdownWithoutLoader
      {...props}
      ref={ref}
      companies={companies.data}
      customerId={customerId}
      disabled={disabled}
    />
  );
});
